/**
 * U SSO
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Credential params that will be requested from the subject.
 */
export interface PresentationRequestCredentialDataParams { 
    /**
     * Name of the credential, for example: \'Employee\' or \'Fan\' or ...
     */
    credentialName: string;
    /**
     * Whether this field should be mandatory to the subject.
     */
    required: boolean;
    /**
     * Optional, credential minimum level of assurance, possible settings: \'LOW\' or \'SUBSTANTIAL\' or \'HIGH\', defaults to \'LOW\'.
     */
    minimumLevelOfAssurance?: string;
}

